<!-- 图片上传组件 -->
<template>
	<el-upload
		v-loading="loading"
		class="avatar-uploader"
		:action="action"
		:headers="headers"
		:disabled="disabled"
		:show-file-list="false"
		:on-error="handleError"
		:on-success="handleSuccess"
		:on-progress="onProgress"
		:accept="accept"
		:data="params"
		:before-upload="beforeAvatarUpload"
	>
		<img v-if="_imageUrl" ref="img" :src="_imageUrl" class="avatar" @load="onLoad">
		<div v-else slot="trigger" class="el-upload__tip">{{ $t('certification.add.pic') }}</div>
		<span v-if="reuplaodBtn" class="reupload-text">{{ $t('certification.add.reupload') }}</span>
	</el-upload>
</template>

<script>
import { configUrl } from '@/lib/configUrl.js'
export default {
	name: 'SingleImageUpload',
	props: {
		value: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		action: {
			type: String,
			default: configUrl + '/merchant/acquirer/file/upload'
		},
		accept: {
			type: String,
			default: 'image/*'
		}
	},
	data() {
		return {
			imageUrl: '',
			localImageUrl: '',
			loading: false,
			key: null,
			domain: this.getMerchantFilesUrl(),
			headers: {
				accessToken: window.sessionStorage.getItem('accessToken')
			}
		}
	},
	computed: {
		reuplaodBtn() {
			return this.imageUrl
		},
		params() {
			return {
				oldFileName: this.value
			}
		},
		_imageUrl: {
			get() {
				if (this.localImageUrl) {
					return this.localImageUrl
				} else {
					return this.imageUrl
				}
			}
		}
	},
	watch: {
		value: {
			handler: function(val, oldVal) {
				if (val) {
					this.imageUrl = `${this.domain}/selectFile/${val}`
				}
			},
			immediate: true
		}
	},
	created() {
		// 监听 storage 事件
		window.addEventListener('storage', this.updateHeaders)
	},
	beforeDestroy() {
		// 清理监听器
		window.removeEventListener('storage', this.updateHeaders)
	},
	methods: {
		updateHeaders() {
			this.headers = {
				accessToken: window.sessionStorage.getItem('accessToken')
			}
		},
		handleSuccess(response, file, fileList) {
			const { data = null, code = null } = response
			if (code == '200' && data) {
				this.localImageUrl = URL.createObjectURL(file.raw)
				this.$emit('input', data.fileName)
			} else {
				this.$message.error(this.$t('certification.add.uploadFailed'))
				this.loading = false
			}
		},
		beforeAvatarUpload(file) {
			const imgMapper = [
				'image/jpeg',
				'image/jpg',
				'image/png',
				'image/bmp'
			]
			const validImg = imgMapper.includes(file.type)
			if (!validImg) {
				this.$notify.error({
					title: this.$t('certification.add.pictureFormatError'), // "图片格式错误",
					message: this.$t('certification.add.uploadLimited') // "图片应为JPG、JPEG、PNG、BMP格式"
				})
				return validImg
			}
			const isLt10M = file.size / 1024 / 1024 < 10
			if (!isLt10M) {
				this.$notify.error({
					title: this.$t('certification.add.notice'), // "注意",
					message: `${this.$t(
						'certification.add.uploadFileNotice'
					)}10MB` // "上传图片大小不能超过 10MB!"
				})
				return isLt10M
			}
		},
		onLoad() {
			this.loading = false
		},
		onProgress(event, file, fileList) {
			this.loading = true
		},
		handleError(err, file, fileList) {
			console.error(err)
			this.loading = false
			this.$message.error(this.$t('certification.add.uploadFailed'))
		}
	}
}
</script>
<style lang='scss' scoped>
.avatar-uploader {
	width: 184px;
	height: 138px;
	background: #f9f9f9;
	::v-deep .el-upload {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		.el-upload__tip {
			font-style: normal;
			font-family: PingFangSC-Regular;
			font-size: 14px;
			color: rgba(0, 0, 0, 0.65);
			letter-spacing: 0;
		}
		.reupload-text {
			display: inline-block;
			padding: 0px 10px;
			line-height: 32px;
			border-radius: 20px;
			background: rgba(255, 255, 255, 0.9);
			position: absolute;
			color: #1fa0e8;
			font-size: 14px;
			opacity: 0;
			font-weight: 500;
		}
	}
	.el-upload:hover .reupload-text {
		opacity: 1;
	}
	img {
		display: inline-block;
		width: 100%;
		height: 100%;
	}
}
</style>
